<div class="asset-search-container">
    <label>
        Asset IDs
        <input id="asset-id" [(ngModel)]="searchText" (ngModelChange)="searchUpdated.next(searchText)"
               placeholder="Enter comma separated ID list">
    </label>
    <div *ngIf="showResults">Select one of the following search results:</div>
    <div class="result-container" *ngIf="showResults">
        <div *ngFor="let prop of propertiesArray" tabindex="-1">
            <button class="resultSet" (click)="selectResults(prop)" [disabled]="prop.data?.length === 0">
                <span class="displayName">{{ prop.displayName }} ({{ prop.data?.length }} of {{ idCount }} valid)</span><br>
                <span>{{ prop.data?.join(',') }}</span>
                <span *ngIf="prop.data?.length == 0">No Matching Ids</span>
            </button>
        </div>
    </div>
</div>
